import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../reducers/app';
import { RootState } from '../root-reducer';
import styled from 'styled-components';
import { sizes } from '../themes/sizes';
import { colors } from '@nextinq/ui-toolkit';

const Container = styled.section`
  position: fixed;
  top: 0;
  left: 60px;
  right: 60px;
`;
const Wrapper = styled.section`
  margin: 0 auto;
  padding: ${sizes.margins.large};
  border: 1px solid ${colors.status.error};
  border-bottom-left-radius: ${sizes.margins.small};
  border-bottom-right-radius: ${sizes.margins.small};
  color: ${colors.status.error};
  background-color: ${colors.statusBg.error};
  width: calc(80vw -120px);
  text-align: center;
`;

export interface AppNotificationProps {
  showAppError: boolean;
  lastErrorMessage: string | null;
}

export function $AppNotification(props: AppNotificationProps) {
  if (!props.showAppError) {
    return null;
  }
  return (
    <Container>
      <Wrapper>{props.lastErrorMessage || ''}</Wrapper>
    </Container>
  );
}

function mapStateToProperties(state: RootState): AppState {
  const app = state.app;
  return app;
}

export const AppNotification = connect(mapStateToProperties)($AppNotification);
